import {
  ChangeDetectionStrategy,
  Component,
  computed,
  CUSTOM_ELEMENTS_SCHEMA,
  input,
  linkedSignal,
  output,
} from '@angular/core';

import { AppSharedModule } from '../../../../../../app-shared.module';
import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from '../../../../../../services/otel.service';
import { DocumentScoringPanel } from '../document-scoring-metrics.component';

@EnableClassTelemetry()
@Component({
  selector: 'app-document-scoring-metrics-section',
  imports: [AppSharedModule],
  templateUrl: './document-scoring-metrics-section.component.html',
  styleUrl: './document-scoring-metrics-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DocumentScoringMetricsSectionComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();

  panel = input.required<DocumentScoringPanel>();

  expandedChanged = output<DocumentScoringPanel>();

  isExpanded = linkedSignal<boolean>(() =>
    this.panel().expanded !== undefined ? this.panel().expanded : true
  );
  header = computed<string>(() => this.panel().header);
  icon = computed(() => (this.isExpanded() ? 'single_arrow_down' : 'single_arrow_up'));

  toggleExpanded() {
    this.isExpanded.set(!this.isExpanded());
    this.expandedChanged.emit({
      ...this.panel(),
      expanded: this.isExpanded(),
    });
  }
}
